// @flow

import R from 'ramda';
import React from 'react';
import { Dropdown, Tooltip } from '../../core';
import {
  toSelectValue,
  objectKeysToSelectFormat,
  sortByLabel,
  DEFAULT_DRUID_FILTERS_LIST
} from './utils';
import { updateDimensionsWithDate } from '../DruidQueryBuilder/utils';
import { isFraudDimensionInFilter } from '../../../../main/screens/ScreenAdsFraud/fraudUtils';
import DataLimitWarning from './DataLimitWarning';

type Props = {
  allFilters: Object,
  dimensions: Array<string>,
  dimensionsToDisplay: Array<string>,
  customLabelMap?: Object,
  maxDimensions: number,
  minDimensions: number,
  updateFraudTypeOnCompareByChange?: () => void,
  updateQuery: (query: Object) => void,
  recordLimit?: number,
  context?: string,
  granularity?: string,
  query?: Object,
  organic?: boolean
};

class CompareBy extends React.PureComponent<Props> {
  /**
   *  Updates dimensions data
   *  Sends onChange data to parent
   */
  updateCompareBy = (dimensions: Array<string>) => {
    const { maxDimensions, minDimensions, granularity } = this.props;
    let newDimensions = [...dimensions];

    if (dimensions.length < minDimensions) {
      return;
    }

    if (dimensions.length > maxDimensions) {
      // replace the last dimension with the most recently chosen dimension
      newDimensions = [
        ...dimensions.slice(0, maxDimensions - 1),
        dimensions[dimensions.length - 1]
      ];
    }

    // add/remove date_range dimension if necessary
    if (granularity) {
      newDimensions = updateDimensionsWithDate(granularity, newDimensions);
    }

    this.props.updateFraudTypeOnCompareByChange &&
      this.props.updateFraudTypeOnCompareByChange();

    this.props.updateQuery({ dimensions: newDimensions });
  };

  render() {
    const {
      allFilters,
      dimensions,
      dimensionsToDisplay,
      customLabelMap,
      recordLimit,
      context,
      query
    } = this.props;

    const options =
      objectKeysToSelectFormat(
        R.pick(dimensionsToDisplay || DEFAULT_DRUID_FILTERS_LIST, allFilters),
        customLabelMap
      ) || [];

    let values =
      dimensions &&
      dimensions.map(dim => {
        // [EG-3109] make fraud_names / fraud_codes unclearable in CompareBy if there's a filter on either of them
        // this is necessary for the UI-level filtering to work (see filterTableRows in fraudUtils.js)
        const fraudDimensionInFilter = isFraudDimensionInFilter(dim, query);
        return toSelectValue(dim, customLabelMap, fraudDimensionInFilter);
      });

    // [EG-2646] do not show 'date' as a CompareBy dimension in the UI for time series contexts
    if (context && context.endsWith('time-series')) {
      values = values.filter(v => v && v.value !== 'date_range');
    }

    return (
      <div className="h_f-1 h_d-f">
        <span className="h_fw-600 h_mstart-10 h_mt-5 fraud-compare-by-label">
          Compare by
        </span>
        <Dropdown
          testid={`compare-by`}
          i13nLabel={`Compare by`}
          options={options && sortByLabel(options)}
          value={values}
          onChange={e => this.updateCompareBy(e.map(o => o.value))}
          clearable={false}
          multi={true}
          className="h_mstart-10 h_w-100"
          outerClassName="h_w-50"
        />
        <Tooltip
          body={<DataLimitWarning limit={recordLimit} />}
          className={'compare-by__tooltip'}
        />
      </div>
    );
  }
}

export default CompareBy;
